module.exports = __webpack_public_path__ + "static/media/join_us.f3674593.svg";